export default {"src":"/_next/static/media/camping.a473fdb4.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};